export const STEPS = [
  { name: 'Add payers', title: 'Add payers' },
  { name: 'Request new payer', title: 'Request new payer' }
];
